import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import EditIcon from "@mui/icons-material/Edit";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import {
  Avatar,
  Grid,
  Drawer,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  FormLabel,
  RadioGroup,
  Radio,
  DialogActions,
  Stack,
  Popover,
  TextField,
  Container,
} from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";

import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TaskIcon from "@mui/icons-material/Task";
import InternData2 from "../Components/InternData";
import InternStdDetail from "../Components/InternStdDetail";
import PersonIcon from "@mui/icons-material/Person";
import { updateStudentSupervisor } from "./../api/crud";
import { useDispatch, useSelector } from "react-redux";
import { updateSnackbar } from "../redux/action/dataAction";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import CancelIcon from "@mui/icons-material/Cancel";
import { blue, pink } from "@mui/material/colors";
import Chip from "@mui/material/Chip";
import {
  convertDateToString,
  dateDiff,
  timeRemain,
  timeSince,
} from "../utils/function";

import ReactExport from "react-data-export";
import FiberManualRecordOutlinedIcon from "@mui/icons-material/FiberManualRecordOutlined";
import Divider from "@mui/material/Divider";
import {
  GrDocumentPdf,
  GrDocumentText,
  GrLocation,
  GrFormClose,
} from "react-icons/gr";
import { MdExpandMore } from "react-icons/md";
import { SiGooglemaps } from "react-icons/si";
import { FcInfo } from "react-icons/fc";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import InfoIcon from "@mui/icons-material/Info";
import MapIcon from "@mui/icons-material/Map";
import { Assignment, Padding } from "@mui/icons-material";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { set } from "lodash";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;




function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  

  return (
    <TableHead>
      <TableRow sx={{
        backgroundColor: "#b8d1ef",
        color: "blue",
        fontWeight: "bold",
        fontSize: 14,
      }}>
        {headCells.map((headCell) => (
          <TableCell 
            key={headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected, excelDataSet, searchCompnent,showActiveComponent, CountRows, textActive } = props;
  
  


  return (
    <Toolbar
      sx={{
        pl: { sm: 0, xs: 0 },
        pt: { xs: 2, sm: 2 },
        pr: { xs: 1, sm: 1 },
        pb: { xs: 2, sm: 2 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
        display: "block",
        py: 1,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex">
          

          <Box > {CountRows} </Box>

          <ExcelFile
            element={
              <Tooltip title="Export">
                <IconButton>
                  <SimCardDownloadIcon label="export" sx={{ height: 20 }} />
                </IconButton>
              </Tooltip>
            }
            filename="internship ENGBUU"
          >
            <ExcelSheet data={excelDataSet} name="internship">
              <ExcelColumn label="Request Id" value="req_id" />
              <ExcelColumn label="รหัสนิสิต" value="st_id" />
              <ExcelColumn label="ชื่อ - สกุล" value="name" />
              <ExcelColumn label="สาขาวิชา" value="branch" />
              <ExcelColumn label="อาจารย์นิเทศ" value="supervisor" />
              <ExcelColumn label="สถานประกอบการ" value="company" />
              <ExcelColumn label="จังหวัด" value="province" />
              <ExcelColumn label="ที่ตั้งสถานที่ฝึกงาน" value="addressIntern" />
              <ExcelColumn label="ประเภท" value="type_internship" />
              <ExcelColumn label="ช่วงเวลา" value="intern_period" />
              <ExcelColumn label="แจ้งที่ตั้ง" value="form" />

              <ExcelColumn label="ชื่อพี่เลี้ยง" value="auditorName" />
              <ExcelColumn label="ตำแหน่งพี่เลี้ยง" value="auditorPosition" />
              <ExcelColumn label="แผนกพี่เลี้ยง" value="auditorDepartment" />
              <ExcelColumn label="Email พี่เลี้ยง" value="auditorEmail" />
              <ExcelColumn label="เบอร์โทรศัพท์พี่เลี้ยง" value="auditorTel" />
              <ExcelColumn label="ชื่อผู้ประสานงาน/HR" value="hrName" />
              <ExcelColumn label="ตำแหน่งผู้ประสานงาน" value="hrPosition" />
              <ExcelColumn label="แผนกผู้ประสานงาน" value="hrDepartment" />
              <ExcelColumn label="Email ผู้ประสานงาน" value="hrEmail" />
              <ExcelColumn label="เบอร์โทรศัพท์ผู้ประสานงาน" value="hrTel" />
              <ExcelColumn label="ลิ้งค์ Google Map" value="addressUrl" />
              <ExcelColumn
                label="ตำแหน่งงานที่นิสิตปฏิบัติ"
                value="jobPosition"
              />
              <ExcelColumn
                label="ลักษณะงานที่รับผิดชอบ"
                value="jobDescription"
              />
              <ExcelColumn label="Logbook#1" value="logbook1" />
            </ExcelSheet>
          </ExcelFile>
        </Box>

      


        <Box>
          <Stack direction="row" spacing={1}>
            <Box > {showActiveComponent}</Box>

            <Box>{searchCompnent}</Box>
          </Stack>

        </Box>
      </Box>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function InternRequestTable({
  tableData = [],
  tableColumn = [],
  allStaff = [],
  excelDataSet = [],
  textActive,
  setValue,  // รับ setValue โดยตรง
  value,
  onRefreshData 

}) {
  const profile = useSelector((state) => state.profileReducer.profile);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width:767px)');

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [studentSelected, setStudentSelected] = useState(null);
  const [studentSupervisorSelected, setStudentSupervisorSelected] =
    useState(null);
  const [supervisorSelected, setSupervisorSelected] = useState(null);
  const [supervisorRemoveSelected, setSupervisorRemoveSelected] =
    useState(null);

  const [supervisorSelfAssign, setSupervisorSelfAssign] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const rows = tableData;
  const activeRows = rows.filter((row) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Normalize current date to start of day for comparison

    const endDate = new Date(row.end_date);
    
    return endDate >= currentDate; // Keep rows where end_date is today or in the future
  });

  

  const [rowsFilter, setRowsFilter] = useState(activeRows);
  const [checked, setChecked] = useState(false);
  const [textActive2, setTextActive2] = useState("รายชื่อนิสิต");

  
  const handleChange = (event) => {
    setChecked(event.target.checked);
    setTextActive2(event.target.checked ? "รายชื่อนิสิต (ทั้งหมด) " : "รายชื่อนิสิต (อยู่ระหว่างปฏิบัติงาน)");
    if (!event.target.checked) {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Normalize current date to start of day for comparison

      setRowsFilter(rows.filter((row) => {
        const endDate = new Date(row.end_date);
        return endDate >= currentDate; // Keep rows where end_date is today or in the future
      }));
    } else {
      setRowsFilter(rows);
    }
  };

  const headCells = tableColumn;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const intt = () => {
    if(activeRows.length != 0){
    setRowsFilter(activeRows);
    setChecked(false);
    setTextActive2("รายชื่อนิสิต (อยู่ระหว่างปฏิบัติงาน)");
    }
    else{
      setRowsFilter(rows);
      setChecked(true);
      setTextActive2("รายชื่อนิสิต (ทั้งหมด) ");
    }

    setSearchTerm("");
  };

  useEffect(() => {
    intt();
  }, [rows]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const onHandleSearch = (ev) => {
    const { value } = ev.target;
    setSearchTerm(value);

    const filtered = rows.filter((row) => {
      return (
        row.req_id.toString().toLowerCase().includes(value) ||
        row.st_id.toString().toLowerCase().includes(value) ||
        row.name.toLowerCase().includes(value) ||
        row.company.toLowerCase().includes(value) ||
        row.addressIntern.toLowerCase().includes(value)
      );
    });

    setRowsFilter(filtered);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n?.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const onHandleUpdateSupervisor = async (reqId, supervisorId, updatedby) => {
    try {
      // Save current state
      const tempState = {
        tab: value,
        scroll: window.scrollY
      };

      // Perform the update
      await updateStudentSupervisor(reqId, supervisorId, updatedby);
      
      // Show success message
      dispatch(
        updateSnackbar({
          open: true,
          content: "บันทึกสำเร็จ"
        })
      );

      // Reset selected states
      setStudentSupervisorSelected(null);
      setSupervisorRemoveSelected(null);
      setSupervisorSelfAssign(null);

      // Restore UI state
      if (setValue && tempState.tab !== undefined) {
        setValue(tempState.tab);
      }
      
      if (tempState.scroll) {
        window.scrollTo(0, tempState.scroll);
      }

      // Refresh data only once
      if (onRefreshData) {
        onRefreshData();
      }

    } catch (err) {
      console.warn('Error updating supervisor:', err);
      dispatch(
        updateSnackbar({
          open: true,
          content: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
          severity: "error"
        })
      );
    }
  };

  // Dialog close handlers
  const handleCloseAllDialogs = () => {
    setStudentSupervisorSelected(null);
    setSupervisorSelected(null);
    setSupervisorRemoveSelected(null);
    setSupervisorSelfAssign(null);
  };
  
const saveStateBeforeSubmit = () => {
    // เพิ่มการตรวจสอบ value
    if (value !== undefined && value !== null) {
      sessionStorage.setItem('tempTab', value.toString());
    }
    
    const currentScroll = window.scrollY;
    if (currentScroll !== undefined && currentScroll !== null) {
      sessionStorage.setItem('tempScroll', currentScroll.toString());
    }
  };

  const restoreStateAfterSubmit = () => {
    const savedTab = sessionStorage.getItem('tempTab');
    const savedScroll = sessionStorage.getItem('tempScroll');
    
    if (savedTab && setValue) {
      setValue(parseInt(savedTab));
    }
    
    if (savedScroll) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedScroll));
      }, 100);
    }

    if (onRefreshData) {
      onRefreshData();
    }
  };

  

  
  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const displayDialogAdvisor = (
    <Dialog
    open={!!studentSupervisorSelected}
    onClose={handleCloseAllDialogs}
  >
    <DialogTitle>เลือกอาจารย์นิเทศ</DialogTitle>
     <DialogContent sx={{ width: "500px" }}>
        <Grid container>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel id="supervisor-group-label">อาจารย์นิเทศ</FormLabel>
              <RadioGroup
                onChange={(ev) => setSupervisorSelected(ev.target.value)}
                value={supervisorSelected}
                aria-labelledby="supervisor-group-label"
                // defaultValue="female"
                name="radio-buttons-group"
              >
                {allStaff
                  .filter(
                    (staff) =>
                      staff?.b_id == studentSupervisorSelected?.b_id ||
                      (studentSupervisorSelected?.b_id == 7 && staff?.b_id == 4)
                  )
                  .map((item) => {
                    let count = 0; // Initialize count outside the map function

                    return (
                      <Box display="flex" justifyContent="space-between">
                        <FormControlLabel
                          value={item.id}
                          control={<Radio />}
                          label={`${item?.name}`}
                        />

                        <Tooltip
                          title={
                            <div>
                              {item?.internOwn.map((el, elIndex) => {
                                if (el?.internStudent?.name != null) {
                                  count++;
                                  return <div>{el?.internStudent?.name}</div>;
                                }
                                return null; // Ensure a return value for map

                              })}
                            </div>
                          }
                          placement="right"
                        >
                          <Button sx={{ color: "black" }}>
                            <HowToRegIcon />{" "}
                            <span>{item.internOwn.length} คน</span>
                          </Button>
                        </Tooltip>
                      </Box>
                    );
                  })}

                <FormControlLabel
                  value=""
                  control={<Radio />}
                  label="ยังไม่เลือก"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseAllDialogs}>
          ยกเลิก
        </Button>
        <Button
          disabled={supervisorSelected === null}
          variant="contained"
          onClick={() => {
            onHandleUpdateSupervisor(
              studentSupervisorSelected.req_id,
              supervisorSelected,
              profile?.id
            );
          }}
        >
          บันทึก
        </Button>
      </DialogActions>
    </Dialog>
  );

  const displayDialogDelete = (
    <Dialog
      open={!!supervisorRemoveSelected}
      onClose={() => {
        setSupervisorRemoveSelected(null);
      }}
    >
      <DialogTitle id="alert-dialog-title">ยกเลิกการนิเทศ</DialogTitle>

      <DialogActions>
        <Button
          onClick={() => {
            setSupervisorRemoveSelected(null);
          }}
        >
          กลับ
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onHandleUpdateSupervisor(
              supervisorRemoveSelected.req_id,
              "",
              profile?.id
            );
          }}
          autoFocus
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );

  const displayDialogAssign = (
    <Dialog
      open={!!supervisorSelfAssign}
      onClose={() => {
        setSupervisorSelfAssign(null);
      }}
    >
      <DialogTitle id="alert-dialog-title">ยืนยันเลือกนิสิต</DialogTitle>

      <DialogActions>
        <Button
          onClick={() => {
            setSupervisorSelfAssign(null);
          }}
        >
          กลับ
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onHandleUpdateSupervisor(
              supervisorSelfAssign.req_id,
              profile.id,
              profile?.id
            );
          }}
          autoFocus
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );

  

  return (
    <>
      {displayDialogAdvisor}
      {displayDialogDelete}
      {displayDialogAssign}
      <Drawer
        anchor="right"
        open={studentSelected ? true : false}
       
        onClose={() => {
          setStudentSelected(null)
        }}
        
      >
        <div
          className="card-body shadow-lg"
          style={{ width: "100vw", maxWidth: "600px" }}
        >
          <div className="row g-0">
            <div className="col-12 mb-4">
              <Box display="flex" justifyContent="flex-end">
             
              <Button
                onClick={() => {
                  setStudentSelected(null);
                }}
                startIcon={<CloseIcon />}
              >
                { isMobile ? 'Close' :''}
              </Button>
              </Box>

              <InternStdDetail internRequestId={studentSelected?.req_id} />

              <Divider />
              {/* add back button */}
              { isMobile &&(
              <Box display="flex" justifyContent="flex-start">
                <Button
                  onClick={() => {
                    setStudentSelected(null);
                  }}
                  startIcon={<ArrowBackIcon />}
                >
                  { isMobile ? 'BACK' :''}
                </Button>
              </Box>)}

            </div>
            {/* <div className="col-12 ">
              <InternData2 st_id={studentSelected?.st_id} />
            </div> */}
          </div>

          <hr />
          {/* <ActivityLog /> */}
        </div>
      </Drawer>

      <EnhancedTableToolbar
        numSelected={selected.length}
        excelDataSet={excelDataSet}
        textActive={textActive}
        searchCompnent={
          <Stack>
            <TextField
              size="small"
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              value={searchTerm}
              onChange={onHandleSearch}
              label="ค้นหา"
            />
            {searchTerm && (
              <small>ค้นพบ {rowsFilter.length ?? 0} รายการ</small>
            )}
          </Stack>
        }
        showActiveComponent={
          <Box padding={2} pr={2}>

            <Stack direction="row"
              alignItems="center"
              justifyContent="center">

            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={checked}
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'controlled' }}

                />
              }
              label={"แสดงทั้งหมด"}
              sx={{
                margin: 0, // Remove default margin
                '& .MuiTypography-root': { // Style label text
                  fontSize: '0.875rem'
                }
              }}

            />
          </Stack>
          </Box>
        }

        CountRows={

          <Stack direction="row" spacing={1}>
            <Box sx={{
              fontSize: 20,
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: 1 // Adds 16px spacing between items

            }}>
              {textActive2}

            <Chip size="small" sx={{ color: "white", backgroundColor: "#4080ea", pt: 0, pb: 0, pl: 0, pr: 0, fontSize: 12, fontWeight: "bold" }}
              label={`${rowsFilter.length} คน`} /></Box>

          </Stack>
        }
      />

            
          <TableContainer>
            <Table
              sx={{ px: 0 }}
              size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rowsFilter.length}
                headCells={headCells}
              />
              <TableBody>
                {stableSort(rowsFilter, getComparator(order, orderBy))
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row?.name);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (

                      <TableRow
                        hover
                        // onClick={(event) => handleClick(event, row.name)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.req_id}
                        selected={isItemSelected}
                      >
                        <TableCell sx={{ verticalAlign: "top" }}>
                          {index + 1}
                        </TableCell>

                        <TableCell sx={{ verticalAlign: "top" }}>
                          {row.req_id}
                        </TableCell>

                        <TableCell sx={{ minWidth: 260, verticalAlign: "top" }}>
                          <Box display="flex" gap={1}>
                            <Avatar
                              onClick={() => setStudentSelected(row)}
                              role="button"
                              alt="profile"
                              sx={{ width: 30, height: 30 }}
                              src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${row.st_id}`}
                            />
                            <Box>
                              <Box sx={{ fontWeight: "bold", fontSize: 13 , color: "#003366"}}>
                                {row?.name?.split(",")[0]}
                              </Box>
                              <Box sx={{ fontWeight: "bold", fontSize: 12 }}>
                                {row.st_id}
                              </Box>
                              <Box>
                                <span className="badge bg-primary">
                                  {row?.name?.split(",")[1]}
                                </span>
                                <Tooltip title="ข้อมูลนิสิต">
                                  <IconButton
                                    sx={{ height: 35, width: 35 }}
                                    onClick={() => setStudentSelected(row)}
                                  >
                                    <FcInfo />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>

                        <TableCell sx={{ verticalAlign: "top" }}>
                          <Box sx={{ fontWeight: "bold", fontSize: 13 }}>
                            {row.company}
                            <span
                              className="mx-1 badge bg-warning text-dark"
                              // onClick={() => {
                              //   setIsModalOpen(true);
                              // }}
                              // role="button"
                            >
                              {
                                rowsFilter?.filter(
                                  (el) => el.company == row?.company
                                ).length
                              }{" "}
                              คน
                            </span>{" "}
                          </Box>

                          <Box sx={{ fontWeight: "500", fontSize: 12 }}>
                            {" "}
                            <Grid container alignItems="center"
                            >
                              <Grid item xs={1} sx={{
                               
                              }}> 
                              {row.addressUrl && (

                                <Tooltip title="คลิกดูบน Google Map">
                                  <a href={row.addressUrl} target="_blank">
                                    <IconButton sx={{ height: 30, width: 30 }}>
                                      <SiGooglemaps color="red" />
                                    </IconButton>
                                  </a>
                                </Tooltip>
                              )}</Grid>
                              <Grid item xs={11} 
                              >

                              {row.addressIntern}
                              </Grid>
                            </Grid>
                          </Box>

                          <Box>
                            <span className="badge bg-secondary">
                              {row.type_internship}
                            </span>
                          </Box>
                          <Box>
                            <span className="badge bg-warning">
                              {row.intern_period}
                            </span>
                          </Box>
                        </TableCell>
                        <TableCell align="start">
                          <Box display="flex" alignItems="start">
                            {row.supervisor &&
                            profile &&
                            profile.id == row.supervisor ? (
                              <Tooltip
                                title={
                                  row.supervisor &&
                                  allStaff.length &&
                                  allStaff?.find(
                                    (staff) => staff.id === row.supervisor
                                  )?.name
                                }
                              >
                                <Chip
                                  label={
                                    row.supervisor &&
                                    allStaff.length &&
                                    allStaff
                                      ?.find(
                                        (staff) => staff.id === row.supervisor
                                      )
                                      ?.name.split(" ")[0]
                                  }
                                  size="small"
                                  color="success"
                                  variant="outlined"
                                  onDelete={() =>
                                    setSupervisorRemoveSelected(row)
                                  }
                                />
                              </Tooltip>
                            ) : (
                              row.supervisor && (
                                <Tooltip
                                  title={
                                    row.supervisor &&
                                    allStaff.length &&
                                    allStaff?.find(
                                      (staff) => staff.id === row.supervisor
                                    )?.name
                                  }
                                >
                                  <Chip
                                    label={
                                      row.supervisor &&
                                      allStaff.length &&
                                      allStaff
                                        ?.find(
                                          (staff) => staff.id === row.supervisor
                                        )
                                        ?.name.split(" ")[0]
                                    }
                                    size="small"
                                    color="success"
                                    variant="outlined"
                                  />
                                </Tooltip>
                              )
                            )}

                            {/* admin */}
                            {row.supervisor && profile?.role == "0" && (
                              <Tooltip title="แก้ไข">
                                <IconButton
                                  onClick={() => {
                                    setStudentSupervisorSelected(row);
                                  }}
                                >
                                  <EditIcon sx={{
                                    fontSize: 16,
                                  }} color="primary" />

                               
                                </IconButton>
                              </Tooltip>
                            )}

                            <Box>
                              {!row.supervisor && profile?.role == "0" && (
                                <Box>
                                  <Button
                                    onClick={() => {
                                      setStudentSupervisorSelected(row);
                                    }}
                                  >
                                    <PersonAddIcon />
                                    <small className="text-nowrap">
                                      {" "}
                                      เลือกอาจารย์นิเทศ
                                    </small>
                                  </Button>
                                </Box>
                              )}

                              {!row.supervisor && profile && (
                                <Box>
                                  <Button
                                    onClick={() => {
                                      setSupervisorSelfAssign(row);
                                    }}
                                  >
                                    <AssignmentIndIcon />
                                    <small className="text-nowrap">
                                      เลือกนิสิตคนนี้
                                    </small>
                                  </Button>{" "}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ verticalAlign: "top" }}>
                          {new Date().getTime() >=
                          new Date(row.end_date).getTime() ? (
                            <>
                              <Box textAlign="center">
                                <EventAvailableIcon color="success" />
                                <small className="d-block text-nowrap ">
                                  เสร็จสิ้น
                                </small>
                                {/* <small className="d-block text-nowrap ">
                                  {timeSince(row.start_date, "thai")}
                                </small> */}
                              </Box>
                              <Tooltip
                                title={`${Math.floor(
                                  (dateDiff(row.end_date, row.start_date) /
                                    dateDiff(row.end_date, row.start_date)) *
                                    100
                                )}%`}
                              >
                                <div
                                  className="progress-bar bg-success"
                                  role="progressbar"
                                  aria-label="Segment two"
                                  style={{
                                    width: `${Math.floor(
                                      (dateDiff( row.end_date, row.start_date) /
                                        dateDiff(
                                          row.end_date,
                                          row.start_date
                                        )) *
                                        100
                                    )}%`,
                                    height: "3px",
                                    backgroundColor: "#00FF15",
                                  }}
                                />
                              </Tooltip>
                            </>
                          ) : new Date().getTime() >=
                            new Date(row.start_date).getTime() ? (
                            <>
                              <Box textAlign="center">
                                <EventAvailableIcon color="success" />
                                <small className="d-block text-nowrap ">
                                  เหลืออีก
                                </small>
                                <small className="d-block text-nowrap ">
                                  {timeRemain(row.end_date, "thai")}
                                </small>
                              </Box>
                              <Tooltip
                                title={`${Math.floor(
                                  (dateDiff(new Date(), row.start_date) /
                                    dateDiff(row.end_date, row.start_date)) *
                                    100
                                )}%`}
                              >
                                <div
                                  className="progress-bar bg-success"
                                  role="progressbar"
                                  aria-label="Segment two"
                                  style={{
                                    width: `${Math.floor(
                                      (dateDiff(new Date(), row.start_date) /
                                        dateDiff(
                                          row.end_date,
                                          row.start_date
                                        )) *
                                        100
                                    )}%`,
                                    height: "3px",
                                    backgroundColor: "#00FF15",
                                  }}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            <Box textAlign="center">
                              <CalendarTodayIcon sx={{ color: "gray" }} />
                              <small className="d-block text-nowrap">
                                ยังไม่ฝึกงาน
                              </small>
                              <small className="d-block text-nowrap ">
                                {row.start_date}
                              </small>
                            </Box>
                          )}

                          <Box display="flex" justifyContent="center" alignItems="center">
                            <Tooltip title="รายงานฝึกงาน 2 เดือน">
                              <Box textAlign="center" mx={0.5}>
                                {row.internReport && (
                                  <a href={row.internReport.link} target="_blank" rel="noopener noreferrer">
                                    <Assignment sx={{ fontSize: "16px" }} />
                                  </a>
                                )}
                              </Box>
                            </Tooltip>

                            <Tooltip title="รายงานสหกิจศึกษา">
                              <Box textAlign="center" mx={0.5}>
                                {row.coopReport && (
                                  <a href={row.coopReport.link} target="_blank" rel="noopener noreferrer">
                                    <TaskIcon sx={{ fontSize: "16px", color: "green"

                                    }} />
                                  </a>
                                )}
                              </Box>
                            </Tooltip>
                          </Box>

                        </TableCell>
                        
                        {/* <TableCell>{row.updated_at}</TableCell> */}
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          
          
        

      
      
    </>
  );
}
